<template>
  <v-container>
    <v-row>
      <v-col>
        <h1>Información envio</h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <div>
          <v-text-field
            disabled
            dense
            outlined
            label="Referencia"
            v-model="ultimaRef"
          ></v-text-field>
        </div>
        <v-radio-group v-model="tipoServicio" @change="calculaValorEnvioInter()">
          <v-radio @click="cambiarNumeroEnvios()" label="Mensajeria" value="1"></v-radio>
          <v-radio label="Paquetería" value="2"></v-radio>
        </v-radio-group>
        <div class="mtll">
          <v-select
            dense
            v-if="tipoServicio == 2"
            outlined
            style="margin-top:10px;"
            label="Número de envios"
            @input="
              cambiarNumeroEnvios();
              calculaValorEnvioInter();
            "
            :items="itemsNumeroDeEnvios"
            v-model="numeroDeEnvios"
          ></v-select>
        </div>

        <!-- <div class="mtll">
          <v-text-field
            dense
            outlined
            v-if="tipoServicio == 2 && numeroDeEnvios == 1"
            v-model="infoEnvio.Paquetes.InfoPaquetes[0].pesokg"
            label="Peso en kilogramos"
            @focus="$event.target.select()"
          ></v-text-field>
        </div> -->
        <div class="mtll">
          <v-select
            dense
            outlined
            @input="calculaValorEnvioInter()"
            v-model="pesoMensajeria"
            v-if="tipoServicio == 1 && numeroDeEnvios == 1"
            label="Peso mensajería"
            :items="itemsPesoMensajeria"
            item-text="etiqueta"
            item-value="valor"
          ></v-select>
        </div>
        <div class="mtll" v-if="multiEnvios.length == 1 && tipoServicio == 1">
          <v-text-field
            dense
            @input="cortadorDeGuias()"
            outlined
            v-model="guiaRastreo"
            @focus="$event.target.select()"
            label="Guia de rastreo"
          ></v-text-field>
        </div>
        <!-- <div class="mtll">
          <v-text-field
            dense
            outlined
            disabled
            @focus="$event.target.select()"
            v-if="tipoServicio == 2 && numeroDeEnvios == 1"
            v-model="multiEnvios[0].pesovol"
            label="Peso volumétrico"
          ></v-text-field>
        </div> -->
        <!-- <h2 v-if="tipoServicio == 2 && numeroDeEnvios == 1">Medidas</h2>
        <div v-if="tipoServicio == 2 && numeroDeEnvios == 1" class="d-flex mtll">
          <v-text-field
            dense
            @focus="$event.target.select()"
            v-model="multiEnvios[0].largo"
            @input="calculaPesoVolFinal()"
            outlined
            label="Largo"
          ></v-text-field>
          <v-text-field
            dense
            @focus="$event.target.select()"
            v-model="multiEnvios[0].alto"
            @input="calculaPesoVolFinal()"
            outlined
            label="Alto"
          ></v-text-field>
          <v-text-field
            dense
            @focus="$event.target.select()"
            v-model="multiEnvios[0].ancho"
            @input="calculaPesoVolFinal()"
            outlined
            label="Ancho"
          ></v-text-field>
        </div> -->
      </v-col>
      <v-col>
        <v-radio-group
          @change="
            cambiaMenus();
            calculaValorEnvioInter();
          "
          column
          v-model="lejaniaDestino"
        >
          <v-radio ref="internacional" value="1" label="Internacional"></v-radio>
          <v-radio ref="nacional" value="2" label="Nacional"></v-radio>
          <v-radio v-if="1 == 2" disabled ref="regional" value="3" label="Regional"></v-radio>
        </v-radio-group>
        <v-radio-group
          @change="calculaValorEnvioInter()"
          v-model="tipoInternacional"
          v-if="lejaniaDestino == 1"
          row
        >
          <v-radio value="1" label="Priority"></v-radio>
          <v-radio value="2" label="Economy"></v-radio>
        </v-radio-group>
        <v-radio-group v-model="tipoNacional" v-if="lejaniaDestino == 2" row>
          <v-radio value="1" label="Dia siguiente"></v-radio>
          <v-radio value="2" label="Terrestre"></v-radio>
        </v-radio-group>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <div class="mtll">
          <v-simple-table
            style="word-break:break-all;"
            v-if="multiEnvios.length >= 1 && tipoServicio == 2"
          >
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-center">
                    <span style="font-weight:bold;font-size:16px;">
                      #
                    </span>
                  </th>
                  <th style="max-width:60px;" class="text-center">
                    <span style="font-weight:bold;font-size:15px;">
                      PESO KG.
                    </span>
                  </th>

                  <th style="max-width:60px;" v-if="tipoServicio == 2" class="text-center">
                    Largo
                  </th>
                  <th style="max-width:60px;" v-if="tipoServicio == 2" class="text-center">
                    Ancho
                  </th>
                  <th v-if="tipoServicio == 2" class="text-center">
                    Alto
                  </th>
                  <th style="max-width:60px;" v-if="tipoServicio == 2" class="text-center">
                    <span style="font-weight:bold;font-size:15px;">
                      PESO VOL.
                    </span>
                  </th>
                  <th v-if="1 > 2" class="text-center">
                    Guia rastreo
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in multiEnvios" :key="index">
                  <td>{{ index + 1 }}</td>
                  <td style="max-width:60px;">
                    <v-text-field
                      dense
                      @input="calculaValorEnvioInter()"
                      @focus="$event.target.select()"
                      class="text-center"
                      v-model="multiEnvios[index].pesokg"
                      outlined
                    ></v-text-field>
                  </td>

                  <td style="max-width:60px;" v-if="tipoServicio == 2">
                    <v-text-field
                      dense
                      @input="calculaPesoVolFinal(index)"
                      @focus="$event.target.select()"
                      v-model="multiEnvios[index].largo"
                      outlined
                    ></v-text-field>
                  </td>
                  <td style="max-width:60px;" v-if="tipoServicio == 2">
                    <v-text-field
                      dense
                      @input="calculaPesoVolFinal(index)"
                      @focus="$event.target.select()"
                      v-model="multiEnvios[index].ancho"
                      outlined
                    ></v-text-field>
                  </td>
                  <td style="max-width:60px;" v-if="tipoServicio == 2">
                    <v-text-field
                      dense
                      :ref="'alto' + index"
                      @input="calculaPesoVolFinal(index)"
                      @focus="$event.target.select()"
                      v-model="multiEnvios[index].alto"
                      @keydown.tab="tabularGuias(index)"
                      outlined
                    ></v-text-field>
                  </td>
                  <td style="max-width:60px;" v-if="tipoServicio == 2">
                    <v-text-field
                      disabled
                      dense
                      :ref="'pesoVol' + index"
                      @focus="$event.target.select()"
                      class="text-center"
                      v-model="multiEnvios[index].pesovol"
                      outlined
                    ></v-text-field>
                  </td>
                  <td v-if="1 > 2">
                    <v-text-field
                      dense
                      @input="cambiaDeGuiaAInsertar(index)"
                      @keyup.down="tabularGuiasEntreEllas(index, 'abajo')"
                      @keyup.up="tabularGuiasEntreEllas(index, 'arriba')"
                      :ref="'guiaNumber' + index"
                      tabindex="-1"
                      @focus="$event.target.select()"
                      v-model="multiEnvios[index].guia"
                      outlined
                    ></v-text-field>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          <div v-if="multiEnvios.length > 1">
            <v-chip color="blue" dark class="mr-4">
              TOTAL PESO KG:
              <v-chip class="ml-4" color="blue darken-4">
                {{ kilosTotalesEnvioActual }}
              </v-chip>
            </v-chip>
            <v-chip color="blue darken-4" dark>
              TOTAL PESO VOL:
              <v-chip class="ml-4" color="blue">
                {{ kilosTotalesVolumetricosEnvioActual }}
              </v-chip>
            </v-chip>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-combobox
          v-model="descripcionInter"
          v-if="tipoServicio == 2 && lejaniaDestino == 1"
          dense
          @change="calculaValorEnvioInter()"
          @input="calculaValorEnvioInter()"
          :items="[
            'MEDAL',
            'DOCUMENTOS',
            'ROPA Y ZAPATOS',
            'ACCESORIOS',
            'ART DE HOGAR',
            'ART DE OFICINA',
            'MUESTRARIOS',
            'BISUTERÍA',
            'ORO',
            'ELECTRÓNICOS'
          ]"
          outlined
          label="Descripcion paquetería internacional"
        ></v-combobox>
      </v-col>
      <!-- <v-col cols="12">
        <v-text-field
        v-if="tipoServicio==2 && lejaniaDestino==1"
          v-model="descripcionInter"
          dense
          outlined
          label="Descripcion mensajería internacional"
        ></v-text-field>
      </v-col> -->
    </v-row>
    <v-row v-if="lejaniaDestino == 1 && tipoServicio == 2">
      <v-col cols="12" v-if="fraccionesMultiEnvios.length != 0">
        <div v-for="(item, index) in fraccionesMultiEnvios" :key="index">
          <v-chip color="primary"> ENVÍO # {{ index + 1 }} </v-chip>

          <v-simple-table style="word-break:break-all;">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-center">
                    Descripción
                  </th>
                  <th class="text-center">
                    Número clasificación
                  </th>
                  <th class="text-center">
                    Cantidad
                  </th>
                  <th class="text-center">
                    Valor unitario
                  </th>
                  <th class="text-center">
                    Subtotal
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item2, index2) in item.fa" :key="index2">
                  <td>
                    <span class="text-center">{{ item2.nombre }}</span>
                  </td>
                  <td>
                    <span class="text-center">{{ item2.num_clasificacion }}</span>
                  </td>
                  <td>
                    <span class="text-center">{{ item2.cantidad }}</span>
                  </td>
                  <td>
                    <span class="text-center">{{ item2.valor_unitario }}</span>
                  </td>
                  <td>
                    <span class="text-center">{{ item2.subtotal }}</span>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </v-col>

      <v-col cols="12">
        <v-btn block color="blue darken-1" dark @click="agregarFraccionesEnvioUnico()"
          >agregar fracciones arancelarias</v-btn
        >
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <!-- // si es paqueteria nacional se muestra -->
        <v-text-field
          dense
          v-if="tipoServicio == 2 && lejaniaDestino == 2"
          v-model="descripcion"
          outlined
          @focus="ordenarEnviosPorKilos()"
          label="Descripción paqueteria nacional"
        ></v-text-field>
        <v-combobox
          dense
          outlined
          v-model="descripcionMensajeria"
          v-if="tipoServicio == 1"
          label="Descripción mensajeria"
          :items="itemsDescripcionMensajeria"
          item-text="valor"
          item-value="clave"
        ></v-combobox>
      </v-col>
    </v-row>
    <v-row>
      <!-- TODO servicios adicionales -->
      <v-col cols="12">
        <h3>
          Servicios adicionales
        </h3>
      </v-col>
      <v-col cols="12" lg="12">
        <div class="display: flex;flex-flow: row nowrap;">
          <!-- empaque solo es para paqueteria y solo si no hay rempaque-->
          <div class="mr-5" v-if="!reempaqueSA && tipoServicio == 2">
            <v-checkbox
              v-model="empaqueSA"
              @input="actualizaPrecioEnvio()"
              label="Empaque"
            ></v-checkbox>
          </div>
          <!-- rempaque solo es para paqueteria y solo si no hay empaque-->
          <div class="mr-5" v-if="!empaqueSA && tipoServicio == 2">
            <v-checkbox
              @input="actualizaPrecioEnvio()"
              v-model="reempaqueSA"
              label="Reempaque"
            ></v-checkbox>
          </div>
          <div v-if="tipoServicio == 2 && lejaniaDestino == 1" class="mr-5">
            <v-checkbox
              disabled
              @input="actualizaPrecioEnvio()"
              v-model="flat5"
              label="FLAT 5"
            ></v-checkbox>
          </div>
          <div v-if="tipoServicio == 2 && lejaniaDestino == 1" class="mr-5">
            <v-checkbox
              disabled
              @input="actualizaPrecioEnvio()"
              v-model="flat19"
              label="FLAT 19"
            ></v-checkbox>
          </div>

          <!-- zona extendida solo es para paqueteria nacional -->
          <div class="mr-5" v-if="tipoServicio == 2 && lejaniaDestino == 2">
            <v-checkbox
              @input="actualizaPrecioEnvio()"
              v-model="zonaExtendedidaSA"
              label="Zona extendida"
            ></v-checkbox>
          </div>
          <div class="mr-5">
            <v-checkbox
              @input="actualizaPrecioEnvio()"
              v-model="recoleccionSA"
              label="Recolección"
            ></v-checkbox>
          </div>
          <div class="mr-5">
            <v-checkbox
              @input="actualizaPrecioEnvio()"
              v-model="entregaSabado"
              label="Entrega en sábado"
            ></v-checkbox>
          </div>

          <div class="mr-5">
            <v-checkbox v-model="seguroSA" label="Seguro"></v-checkbox>
          </div>
        </div>
      </v-col>
      <!-- seccion de seguro nacional -->
      <v-col cols="12" v-if="seguroSA && lejaniaDestino == 2">
        <div class="d-flex mtll mtl2">
          <v-text-field
            @input="calculaSeguroNacional"
            @focus="$event.target.select()"
            class="mr-2"
            v-model.trim="valorContenidoNacional"
            outlined
            dense
            label="Valor del contenido"
          ></v-text-field>
          <v-text-field
            disabled
            @focus="$event.target.select()"
            v-model.trim="valorSeguroNacional"
            outlined
            dense
            label="Seguro"
          ></v-text-field>
        </div>
      </v-col>
      <!-- seccion de seguro internacional -->
      <v-col v-if="seguroSA && lejaniaDestino == 1">
        <div class="d-flex mtll mtl2">
          <v-text-field
            @input="calculaSeguroDeEsteEnvio()"
            @focus="$event.target.select()"
            class="mr-2"
            v-model.trim="valorContenido"
            outlined
            dense
            label="Valor del contenido"
          ></v-text-field>
          <!-- TODO seguros -->
          <v-select
            v-model="porcentajeSeguroAplicable"
            item-text="descripcion"
            item-value="valor"
            :items="valoresSegurosDeEnvio"
            outlined
            clearable
            dense
            @input="calculaSeguroDeEsteEnvio()"
            label="Categoria de seguro"
            class="mr-2"
          ></v-select>
          <v-text-field
            @focus="$event.target.select()"
            outlined
            dense
            disabled
            class="mr-2"
            label="Ajuste de tarifa"
            v-model="regresaValorSeguro"
          ></v-text-field>
          <v-text-field
            @focus="$event.target.select()"
            outlined
            @input="actualizaPrecioEnvio()"
            dense
            v-model="seguro"
            label="Seguro"
          ></v-text-field>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-textarea
        style="height:0;width:0;opacity:0;"
        ref="textAreaDeDatosACopiar"
        id="textAreaDeDatosACopiar"
        v-model="datosQueSeVanACopiar"
        solo
        name="input-7-4"
        label="Solo textarea"
      ></v-textarea>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-text-field
          dense
          disabled
          v-model="autoriza"
          outlined
          label="Autoriza"
          value="IPS"
        ></v-text-field>
      </v-col>
      <v-col cols="6" style="display:flex;">
        <v-text-field
          style="opacity:0;max-width:1px;max-height:0px;height:0px;width:0px;"
          id="numeroDeCuentaACopiarPortapapeles"
          v-model="numeroDeCuentaQueSeEstaUsando"
        >
        </v-text-field>
        <v-select
          dense
          @input="actualizaCuentaUtilizada()"
          v-model="infoEnvio.Cuenta"
          item-text="CUENTA"
          item-value="ID"
          :items="cuentasList"
          outlined
          label="Cuenta utilizada"
        ></v-select>
        <v-btn class="ml-1" @click="copiarCuentaPortapapeles()" color="blue" dark outlined
          >copiar cuenta<v-icon medium class="mr-2"> content-copy </v-icon></v-btn
        >
      </v-col>
    </v-row>
    <v-row v-if="mostrarMultiplicadorInter" style="margin-top:-10px;">
      <v-col cols="6">
        <v-text-field
          dense
          @focus="$event.target.select()"
          outlined
          @input="precioMultiplicado = Math.ceil(costoEnvioInterAMultiplicar * 1.7)"
          v-model.trim="costoEnvioInterAMultiplicar"
          label="Cotización Ship Manager"
        ></v-text-field>
      </v-col>
      <v-col cols="6"
        ><v-text-field
          dense
          outlined
          @focus="$event.target.select()"
          v-model.trim="precioMultiplicado"
          label="Precio multiplicado"
        ></v-text-field
      ></v-col>
    </v-row>
    <v-row>
      <v-col cols="12" xl="3">
        <v-text-field
          dense
          style=""
          outlined
          @input="actualizaPrecioEnvio()"
          @focus="$event.target.select()"
          v-model.trim="costoEnvio"
          label="Costo envio"
        ></v-text-field>
        <v-select
          dense
          v-model="metodoPago"
          item-text="texto"
          item-value="valor"
          :items="['Efectivo', 'Transferencia', 'Deposito']"
          label="Método de pago"
          outlined
        ></v-select>
      </v-col>
      <v-col cols="12" xl="3">
        <v-text-field
          color="blue"
          dense
          class="estiloValorTotal"
          outlined
          @click="$event.target.select()"
          @focus="$event.target.select()"
          v-model.trim="infoEnvio.Pagos.total"
          label="VALOR TOTAL ENVÍO"
        ></v-text-field>
        <v-switch inset label="Pago completo" v-model="pagoCompleto"></v-switch>
      </v-col>
      <v-col v-if="!pagoCompleto" cols="12" xl="3">
        <v-text-field
          dense
          v-model="infoEnvio.Pagos.Abonos[0].cantidad"
          outlined
          @focus="$event.target.select()"
          label="Abono"
        ></v-text-field>
      </v-col>
      <v-col cols="12" xl="3">
        <v-text-field
          dense
          disabled
          outlined
          label="Tipo tarifa"
          :value="descripcionTarifa"
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" lg="6" xl="6">
        <v-btn
          ref="botonCompletarALV"
          :disabled="deshabilitarBotonCompletar"
          block
          color="success"
          @click="
            copiarALV();
            completarEnvio();
          "
          >COMPLETAR ENVIO</v-btn
        >
      </v-col>
      <v-col cols="12" lg="6" xl="6">
        <v-btn @click="cancelarLimpiarEnvio()" block color="error">CANCELAR</v-btn>
      </v-col>
    </v-row>
    <v-row no-gutters v-if="1 > 2">
      <v-col cols="12">
        <v-btn block color="purple" dark @click="copiarALV()">COPIAR DATOS ENVIO</v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col style="float:right;" cols="12">
        <v-checkbox
          v-model="switchMantenerdatosEnPantalla"
          label="Mantener datos en pantalla para siguiente envio"
        ></v-checkbox>
      </v-col>
    </v-row>
    <v-overlay :value="loaderAntesDeEnvios">
      <v-progress-circular indeterminate size="100"></v-progress-circular>
    </v-overlay>
    <ModalErrorEnAccion
      :mensajeError="mensajeErrorModalErrorEnAccion"
      :show="dialogErrorEnAccion"
      @cerrarModalEnAccion="dialogErrorEnAccion = false"
    />
    <ModalEdicionEnvios
      :queInterfazMeLlama="'agregarEnvios'"
      :informacionPasadaParaCopiar="datosQueSeVanACopiar"
      @mostrarMensajeError="
        asignaMensajeError($event);
        dialogErrorEnAccion = true;
      "
      @mostrar-mensaje-edicion-envios="
        snackBarAlerta = true;
        mensajeSnackbarAlerta = 'Envío editado con éxito';
        colorSnackBarAlerta = 'blue';
        llamadaMetodoPosteriorAEdicionDeGuias();
      "
      @cerrar-modal-edicion-envios="mostrarModalEdicionEnvios = false"
      v-if="mostrarModalEdicionEnvios"
      :idEnvioEditar="idEnviadaEnvioEditar"
      :show="mostrarModalEdicionEnvios"
    />
    <v-snackbar
      v-model="snackBarEnviocancelado"
      timeout="2000"
      rounded="pill"
      centered
      elevation="8"
      color="blue darken-1"
      ><div style="font-size:20px;text-align:center;">
        Envio cancelado
      </div></v-snackbar
    >
    <v-snackbar
      v-model="snackBarAlerta"
      timeout="2000"
      rounded="pill"
      centered
      elevation="8"
      :color="colorSnackBarAlerta"
      ><div style="font-size:20px;text-align:center;">
        {{ mensajeSnackbarAlerta }}
      </div></v-snackbar
    >
  </v-container>
</template>
<script>
import { mapActions, mapState } from "vuex";
import moment from "moment";
import ModalErrorEnAccion from "@/components/modales/ModalErrorEnAccion.vue";
import ModalEdicionEnvios from "@/components/modales/ModalEdicionEnvios.vue";

export default {
  components: {
    ModalErrorEnAccion,
    ModalEdicionEnvios
  },
  data: () => ({
    idEnviadaEnvioEditar: 0,
    mostrarModalEdicionEnvios: false,

    precioMultiplicado: 0,
    costoEnvioInterAMultiplicar: 0,
    colorSnackBarAlerta: "",
    mensajeSnackbarAlerta: false,
    snackBarAlerta: false,
    deshabilitarBotonCompletar: false,
    flat19: false,
    flat5: false,
    montoServicioGuiaSA: 0,
    descripcionInter: "",
    datosQueSeVanACopiar: "",
    switchMantenerdatosEnPantalla: false,
    snackBarEnviocancelado: false,
    metodoPago: "Efectivo",
    costoEnvio: 0,
    dialogErrorEnAccion: false,
    mensajeErrorModalErrorEnAccion: "",
    valorContenidoNacional: 0,
    valorSeguroNacional: 0,
    porcentajeSeguroAplicable: 3,
    loaderAntesDeEnvios: false,

    guiaRastreo: "",
    montoZonaExtendida: 0,
    montoEntregaSabado: 0,
    montoReempaque: 0,
    montoRecoleccion: 0,
    montoEmpaque: 0,
    infoParaTicket: { InfoPagos: { Total: 0 } },
    seguroSA: false,
    valorContenido: 0,
    seguro: 0,
    recoleccionSA: false,
    entregaSabado: false,
    zonaExtendedidaSA: false,
    empaqueSA: false,
    reempaqueSA: false,
    descripcionMensajeria: "",
    pesoMensajeria: 0.5,
    pagoCompleto: false,
    switchRecoleccion: false,
    valoresSegurosDeEnvio: [
      {
        valor: 2,
        descripcion: "Documentos/Ropa [2%]"
      },
      {
        valor: 5,
        descripcion: "Alimentos/Bisuteria/Ropa [5%]"
      },
      {
        valor: 9,
        descripcion: "Oro/Electrónicos [9%]"
      }
    ],
    multiEnvios: [
      {
        pesokg: 0,
        pesovol: 0,
        largo: 0,
        ancho: 0,
        alto: 0,
        fa: [],
        guia: ""
      }
    ],
    tipoRecoleccion: "2",
    max25chars: v => v.length <= 25 || "Demasiados caracteres",
    numeroDeEnvios: 1,
    itemsDescripcionMensajeria: [
      {
        valor: "FOTOS",
        clave: "1"
      },
      {
        valor: "DOCUMENTOS",
        clave: "2"
      },
      {
        valor: "DOCUMENTOS IMPORTANTES",
        clave: "3"
      }
    ],
    itemsPesoMensajeria: [
      {
        etiqueta: "½ Kilo",
        valor: 0.5
      },
      {
        etiqueta: "1 Kilo",
        valor: 1
      }
    ],
    itemsNumeroDeEnvios: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
    lejaniaDestino: "2",
    tipoInternacional: "1",
    tipoNacional: "1",
    tipoServicio: "2",

    descripcion: "",
    autoriza: "IPS",
    infoEnvio: {
      Sucursal: 1,
      Pagos: {
        total: 0,
        Abonos: [
          {
            fecha: "",
            cantidad: 0
          }
        ]
      },
      Cuenta: 0,
      Tipo_Servicio: "1",
      Paquetes: {
        InfoPaquetes: [
          {
            pesokg: 0,
            pesovol: 0,
            alto: 0,
            ancho: 0,
            largo: 0,
            guia: 1234567
          }
        ]
      },
      Direccion: [
        {
          pais: "",
          estado: "",
          municipio: "",
          codigopostal: "",
          colonia: "",
          direccion: ""
        }
      ],
      DireccionRemitente: [
        {
          estado: "",
          municipio: "",
          codigopostal: "",
          colonia: "",
          direccion: ""
        }
      ]
    }
  }),
  props: {
    fraccionesMultiEnvios: Array
  },
  watch: {
    async "destinatarioActual.pais"() {
      if (this.quitarAcentos(this.destinatarioActual.pais + "").toLowerCase() == "mexico") {
        this.lejaniaDestino = "2";
      } else {
        this.lejaniaDestino = "1";
      }
    },
    async "remitenteActual.tarifaClienteEspecifica.ID"() {
      await this.calculaValorEnvioInter();
    },
    async remitenteActual() {
      if (this.remitenteActual.tarifaClienteEspecifica) {
        await this.calculaValorEnvioInter();
      }
    },

    async flat5() {
      await this.actualizaPrecioEnvio();
    },

    async flat19() {
      if (this.flat19) {
        this.montoServicioGuiaSA = 500;
      } else {
        this.montoServicioGuiaSA = 0;
      }
      await this.actualizaPrecioEnvio();
    },

    descripcionInter() {
      switch (this.descripcionInter) {
        case "ROPA":
          this.porcentajeSeguroAplicable = 2;
          break;
        case "DOCUMENTOS":
          this.porcentajeSeguroAplicable = 2;
          break;
        case "MEDAL":
          this.porcentajeSeguroAplicable = 5;
          break;
        case "BISUTERÍA":
          this.porcentajeSeguroAplicable = 5;
          break;
        case "ORO":
          this.porcentajeSeguroAplicable = 9;
          break;
        case "ELECTRÓNICOS":
          this.porcentajeSeguroAplicable = 9;
          break;
        default:
          break;
      }
      // ROPA', 'ALIMENTOS', 'MEDICAMENTOS', 'BISUTERÍA', 'ORO', 'ELECTRÓNICOS
    },
    async precioMultiplicado() {
      this.costoEnvio = this.precioMultiplicado;
      await this.actualizaPrecioEnvio();
    },

    fraccionesMultiEnvios() {
      this.multiEnvios = JSON.parse(JSON.stringify(this.fraccionesMultiEnvios));
      if (this.multiEnvios.length == 0) {
        this.multiEnvios.push({
          pesokg: 0,
          pesovol: 0,
          largo: 0,
          ancho: 0,
          alto: 0,
          fa: [],
          guia: ""
        });
      }
    },
    zonaExtendedidaSA() {
      if (!this.zonaExtendedidaSA) {
        this.montoZonaExtendida = 0;
      }
      this.actualizaPrecioEnvio();
    },
    empaqueSA() {
      if (!this.empaqueSA) {
        this.montoEmpaque = 0;
      }
      this.actualizaPrecioEnvio();
    },
    reempaqueSA() {
      if (!this.reempaqueSA) {
        this.montoReempaque = 0;
      }
      this.actualizaPrecioEnvio();
    },
    recoleccionSA() {
      if (!this.recoleccionSA) {
        this.montoRecoleccion = 0;
      }
      this.actualizaPrecioEnvio();
    },
    entregaSabado() {
      if (!this.entregaSabado) {
        this.montoEntregaSabado = 0;
      }
      this.actualizaPrecioEnvio();
    },
    async costoEnvio() {
      await this.actualizaPrecioEnvio();
    },
    valorContenidoNacional() {
      if (
        this.valorContenidoNacional == 0 ||
        this.valorContenidoNacional == null ||
        this.valorContenidoNacional == "" ||
        !this.is_numeric(this.valorContenidoNacional)
      ) {
        this.valorSeguroNacional = 0;
        this.actualizaPrecioEnvio();
      }
    },
    seguroSA() {
      //TODO falta hacerlo para internacional
      if (!this.seguroSA && this.lejaniaDestino == 2) {
        this.valorSeguroNacional = 0;
        this.valorContenidoNacional = 0;
        this.actualizaPrecioEnvio();
      } else if (!this.seguroSA && this.lejaniaDestino == 1) {
        this.seguro = 0;
        this.valorContenido = 0;
        this.actualizaPrecioEnvio();
      }
    }
  },

  computed: {
    ...mapState("enviosRemitentes", {
      remitenteActual: state => state.remitente,
      titularDeEnvioActual: state => state.nombreTitularEnvio
    }),
    ...mapState("enviosDestinatarios", {
      destinatarioActual: state => state.destinatario
    }),
    ...mapState("tarifas", {
      tarifasServicios: state => state.descuentos[3].TARIFA.Servicios_adicionales
    }),
    ...mapState("cuentas", {
      cuentasList: state => state.cuentas
    }),
    ...mapState("enviosInsercion", {
      ultimaRef: state => state.ultimaRef
    }),
    ...mapState({
      logedInUserInfo: state => state.sesion.logedInUserInfo,
      sucursalInfo: state => state.sesion.sucursalData,
      numeroDeCuentaQueSeEstaUsando: state => state.sesion.numeroDeCuentaQueSeEstaUsando
    }),
    retornaTitularORemitente() {
      if (this.titularDeEnvioActual != "") {
        return this.titularDeEnvioActual.toUpperCase();
      } else {
        return this.remitenteActual.nombre.toUpperCase();
      }
    },
    cualPesoEsMayorVoloTotal() {
      let obtenMayor = Math.max(
        this.kilosTotalesEnvioActual,
        this.kilosTotalesVolumetricosEnvioActual
      );
      if (obtenMayor <= 0.5) {
        return 0.5;
      } else {
        return Math.ceil(obtenMayor);
      }
    },
    kilosTotalesEnvioActual() {
      let totalKilos = 0;
      for (let i = 0; i < this.multiEnvios.length; i++) {
        totalKilos += parseFloat(
          this.multiEnvios[i].pesokg == "" ||
            this.multiEnvios[i].pesokg == null ||
            !this.is_numeric(this.multiEnvios[i].pesokg)
            ? 0
            : this.multiEnvios[i].pesokg
        );
      }
      return totalKilos;
    },
    kilosTotalesVolumetricosEnvioActual() {
      let totalKilosVol = 0;
      for (let i = 0; i < this.multiEnvios.length; i++) {
        totalKilosVol += parseFloat(
          this.multiEnvios[i].pesovol == "" ||
            this.multiEnvios[i].pesovol == null ||
            !this.is_numeric(this.multiEnvios[i].pesovol)
            ? 0
            : this.multiEnvios[i].pesovol
        );
      }
      return totalKilosVol.toFixed(3);
    },
    mostrarMultiplicadorInter() {
      if (
        this.lejaniaDestino == 1 &&
        this.quitarAcentos(this.destinatarioActual.pais + "").toLowerCase() != "estados unidos" &&
        this.quitarAcentos(this.destinatarioActual.pais + "").toLowerCase() != "canada" &&
        this.quitarAcentos(this.destinatarioActual.pais + "").toLowerCase() != "mexico"
      ) {
        return true;
      } else {
        return false;
      }
    },

    descripcionTarifa() {
      if (this.remitenteActual.tarifaClienteEspecifica) {
        if (this.remitenteActual.tarifaClienteEspecifica.descripcion) {
          return this.remitenteActual.tarifaClienteEspecifica.descripcion;
        }
      } else {
        return "n/d";
      }
    },

    regresaValorSeguro() {
      if (this.remitenteActual.tarifa_seguro) {
        if (this.remitenteActual.tarifa_seguro.length > 0) {
          if (this.remitenteActual.tarifa_seguro == 1 || this.remitenteActual.tarifa_seguro == 2) {
            return `+${this.remitenteActual.tarifa_seguro}`;
          } else {
            return this.remitenteActual.tarifa_seguro;
          }
        } else {
          return 0;
        }
      }
    },
    hayServicioAdicional() {
      if (
        this.entregaSabado ||
        this.empaqueSA ||
        this.reempaqueSA ||
        this.recoleccionSA ||
        this.seguroSA ||
        this.zonaExtendedidaSA ||
        this.flat19 ||
        this.flat5
      ) {
        return true;
      } else {
        return false;
      }
    },
    cualArregloDeItemsRegresar() {
      if (this.tipoServicio == 2) {
        return this.itemsMasDe1Envio;
      }
      return this.itemsMasDe1EnvioMensajeria;
    },
    cualArregloDeHeadersRegresar() {
      if (this.tipoServicio == 2) {
        return this.headersMasDe1Envio;
      }
      return this.headersMasDe1EnvioMensajeria;
    }
  },
  async mounted() {
    await this.getTarifas();
    await this.getUltimaRef();
    await this.asignacionDeCuentas();
    this.getCuentas();
    this.autoriza = this.logedInUserInfo.nombre;
    await this.getSucursalEnLaQueEstoy(this.logedInUserInfo.sucursal);
  },
  async beforeDestroy() {
    await this.destroyDescuentos();
  },
  methods: {
    ...mapActions("enviosRemitentes", ["destroyRemitente"]),
    ...mapActions("enviosDestinatarios", ["destroyDestinatario"]),
    ...mapActions("enviosInfoEnvio", [
      "chargeinfoEnvio",
      "chargeInfoEnvioGeneradaDespues",
      "destroyStoreInfoEnvio"
    ]),
    ...mapActions("abonosEnvios", ["destroyStoreAbonosEnvios"]),
    ...mapActions("ofuscadorFirma", ["convertirVariableTrue", "convertirVariableFalse"]),
    ...mapActions("cuentas", ["getCuentas"]),
    ...mapActions("sesion", ["getSucursalEnLaQueEstoy", "asignaNumeroDeCuentaAUsar"]),
    ...mapActions("enviosInsercion", ["insertEnvios", "getUltimaRef"]),
    ...mapActions("remitentesRegistro", ["insertRemitentes"]),
    ...mapActions("destinatarioRegistro", ["insertDestinatarios"]),
    ...mapActions("insercionDirecciones", ["insertDireccionDest", "insertDireccionRem"]),
    ...mapActions("tarifas", ["getTarifas", "editTarifas", "destroyDescuentos"]),
    muestraSnackBar(a, b, c) {
      this.snackBarAlerta = a;
      this.colorSnackBarAlerta = b;
      this.mensajeSnackbarAlerta = c;
    },
    asignaMensajeError(res) {
      this.mensajeErrorModalErrorEnAccion = JSON.stringify(res);
    },
    async calculaValorEnvioInter() {
      // debemos saber si es inter sino no se deberia usar esta tarifa
      //tambien hay que saber si ya se selecciono un cliente sino dara error
      if (this.lejaniaDestino == 1 && this.remitenteActual.tarifaClienteEspecifica) {
        //si la tarifa no es de publico general asignamos como seguro base 220
        // hasta que se asigne algun valor del contenido para calcular el seguro
        // mas adecuado y correcto
        if (
          !this.remitenteActual.tarifaClienteEspecifica.tarifa.Paqueteria &&
          (this.valorContenido == 0 || this.valorContenido == "" || this.valorContenido == null)
        ) {
          this.seguroSA = true;
          this.seguro = 220;
        } else {
          this.seguro = 0;
          this.seguroSA = false;
        }
        //console.log(this.remitenteActual.tarifaClientePublicoGeneral);
        //console.log(this.remitenteActual.tarifaClientePublicoGeneral);

        //calculamos kilos totales para la tarifa

        if (this.descripcionInter == "MEDAL") {
          if (this.cualPesoEsMayorVoloTotal > 5) {
            this.muestraSnackBar(
              true,
              "red darken-1",
              "Los envíos de MEDAL pueden ser máximo de 5 kilos."
            );
            this.deshabilitarBotonCompletar = true;
          } else {
            if (this.cualPesoEsMayorVoloTotal == 0.5) {
              this.costoEnvio = parseFloat(
                this.remitenteActual.tarifaClientePublicoGeneral.tarifa.Paqueteria.MEDAL[0]
              );
            } else {
              this.costoEnvio = parseFloat(
                this.remitenteActual.tarifaClientePublicoGeneral.tarifa.Paqueteria.MEDAL[
                  this.cualPesoEsMayorVoloTotal
                ]
              );
            }
            this.deshabilitarBotonCompletar = false;
          }
        } else {
          //hay que habilitar el boton si cae en excepcion
          this.deshabilitarBotonCompletar = false;
          // esta condicion aplica si la tarifa del cliente es publico general
          if (this.remitenteActual.tarifaClienteEspecifica.tarifa.Paqueteria) {
            if (this.tipoServicio == 1) {
              // para mensajeria con la tabla que nos pasaron solo
              // se hacen envios inter de medio kilo
              if (this.pesoMensajeria == 0.5) {
                if (this.tipoInternacional == 1) {
                  this.costoEnvio = parseFloat(
                    this.remitenteActual.tarifaClientePublicoGeneral.tarifa.Mensajeria.Primary
                  );
                } else {
                  this.costoEnvio = parseFloat(
                    this.remitenteActual.tarifaClientePublicoGeneral.tarifa.Mensajeria.Economy
                  );
                }
              } else if (this.pesoMensajeria == 1) {
                if (this.tipoInternacional == 1) {
                  this.costoEnvio = parseFloat(
                    this.remitenteActual.tarifaClientePublicoGeneral.tarifa.Paqueteria.Primary[1]
                  );
                } else {
                  this.costoEnvio = parseFloat(
                    this.remitenteActual.tarifaClientePublicoGeneral.tarifa.Paqueteria.Economy[1]
                  );
                }
              }
              // es mensajeria
              //sino, es paqueteria como se muestra aqui
            } else {
              //si los kilos son menores o iguales a 0.5 se usa la posicion cero del arreglo de tarifas
              if (this.cualPesoEsMayorVoloTotal <= 0.5) {
                //1, es priority, 2 es economy
                if (this.tipoInternacional == 1) {
                  this.costoEnvio = parseFloat(
                    this.remitenteActual.tarifaClientePublicoGeneral.tarifa.Paqueteria.Primary[0]
                  );
                } else {
                  this.costoEnvio = parseFloat(
                    this.remitenteActual.tarifaClientePublicoGeneral.tarifa.Paqueteria.Economy[0]
                  );
                }

                // sino, se usa la posicion calculando el costo de los kilos y redondeando
                // hacia arriba
              } else {
                if (this.tipoInternacional == 1) {
                  this.costoEnvio = parseFloat(
                    this.remitenteActual.tarifaClientePublicoGeneral.tarifa.Paqueteria.Primary[
                      this.cualPesoEsMayorVoloTotal
                    ]
                  );
                } else {
                  this.costoEnvio = parseFloat(
                    this.remitenteActual.tarifaClientePublicoGeneral.tarifa.Paqueteria.Economy[
                      this.cualPesoEsMayorVoloTotal
                    ]
                  );
                }
              }
            }
            //esta condicion aplica para todos los clientes con tarifa que no sea de publico general
          } else if (this.remitenteActual.tarifaClienteEspecifica.tarifa.Primary.Paqueteria) {
            //1 es mensajeria
            if (this.tipoServicio == 1) {
              //si es mensajeria de medio kilo cae aqui, con el valor de la tabla
              if (this.pesoMensajeria == 0.5) {
                if (this.tipoInternacional == 1) {
                  this.costoEnvio = parseFloat(
                    this.remitenteActual.tarifaClienteEspecifica.tarifa.Primary.Mensajeria
                  );
                } else {
                  this.costoEnvio = parseFloat(
                    this.remitenteActual.tarifaClienteEspecifica.tarifa.Economy.Mensajeria
                  );
                }
                //si el peso de mensajeria es de 1 kilo tomamos el valor de 1 kilo de paqueteria
              } else if (this.pesoMensajeria == 1) {
                if (this.tipoInternacional == 1) {
                  this.costoEnvio = parseFloat(
                    this.remitenteActual.tarifaClientePublicoGeneral.tarifa.Paqueteria.Primary[1]
                  );
                } else {
                  this.costoEnvio = parseFloat(
                    this.remitenteActual.tarifaClientePublicoGeneral.tarifa.Paqueteria.Economy[1]
                  );
                }
              }
              //lo de arriba es para mensajeria, lo deaqui abajo para paqueteria
            } else {
              if (this.cualPesoEsMayorVoloTotal <= 0.5) {
                //1, es priority, 2 es economy
                if (this.tipoInternacional == 1) {
                  this.costoEnvio = parseFloat(
                    this.remitenteActual.tarifaClienteEspecifica.tarifa.Primary.Paqueteria *
                      this.cualPesoEsMayorVoloTotal
                  );
                } else {
                  this.costoEnvio = parseFloat(
                    this.remitenteActual.tarifaClienteEspecifica.tarifa.Economy.Paqueteria *
                      this.cualPesoEsMayorVoloTotal
                  );
                }

                // sino, se usa la posicion calculando el costo de los kilos y redondeando
                // hacia arriba
                // lo de abajo es para cuando no son envios de medio kilo
              } else {
                if (this.tipoInternacional == 1) {
                  this.costoEnvio = parseFloat(
                    this.remitenteActual.tarifaClienteEspecifica.tarifa.Primary.Paqueteria *
                      this.cualPesoEsMayorVoloTotal
                  );
                } else {
                  this.costoEnvio = parseFloat(
                    this.remitenteActual.tarifaClienteEspecifica.tarifa.Economy.Paqueteria *
                      this.cualPesoEsMayorVoloTotal
                  );
                }
              }
            }
          }
        }
        // en esta ultima parte del if vamos a saber que tipo de flat lleva
        //ocupamos saber si es para clientes publico no general
        if (this.remitenteActual.tarifaClienteEspecifica.tarifa.Primary) {
          if (this.remitenteActual.tarifaClienteEspecifica.tarifa.Primary.Paqueteria) {
            if (this.cualPesoEsMayorVoloTotal <= 5) {
              this.flat5 = true;
              this.flat19 = false;
            } else if (this.cualPesoEsMayorVoloTotal > 5 && this.cualPesoEsMayorVoloTotal <= 19) {
              this.flat5 = false;
              this.flat19 = true;
            } else {
              this.flat5 = false;
              this.flat19 = false;
            }
          }
        } else {
          this.flat5 = false;
          this.flat19 = false;
        }
      } else {
        //excepcion, cae aqui si no es inter
        this.seguroSA = false;
        //la variable seguro es la de seguro inter
        this.seguro = 0;
        //tambien hay que hacer 0 el valor envio
        //ya que no se ocupan las tarifas inter
        this.costoEnvio = 0;
        this.deshabilitarBotonCompletar = false;
        this.flat5 = false;
        this.flat19 = false;
      }
      if (this.tipoServicio == 1) {
        this.flat5 = false;
        this.flat19 = false;
      }
      if (this.descripcionInter == "MEDAL") {
        this.flat5 = false;
        this.flat19 = false;
      }
      //llamamos el metodo para que se actualice el costo de envio
      //este siempre se llama independientemente si es o no inter
      await this.actualizaPrecioEnvio();
    },
    quitarAcentos(cadena) {
      const acentos = {
        á: "a",
        å: "a",
        é: "e",
        í: "i",
        ó: "o",
        ú: "u",
        Á: "A",
        É: "E",
        Í: "I",
        Ó: "O",
        Ú: "U"
      };
      return cadena
        .split("")
        .map(letra => acentos[letra] || letra)
        .join("")
        .toString();
    },
    copiarCuentaPortapapeles() {
      let testingCodeToCopy = document.querySelector("#numeroDeCuentaACopiarPortapapeles");
      testingCodeToCopy.setAttribute("type", "text");
      testingCodeToCopy.select();
      var successful = document.execCommand("copy");
    },
    asignacionDeCuentas() {
      if (this.numeroDeCuentaQueSeEstaUsando != "") {
        for (let i = 0; i < this.cuentasList.length; i++) {
          if (this.cuentasList[i].CUENTA == this.numeroDeCuentaQueSeEstaUsando) {
            this.infoEnvio.Cuenta = this.cuentasList[i].ID;
          }
        }
        // await this.asignaNumeroDeCuentaAUsar(this.cuentasList[indexCuenta].CUENTA);
      }
    },
    async copiarALV() {
      await this.getUltimaRef();
      let lejaniaDestinoCopia = this.lejaniaDestino == 1 ? "Internacional" : "Nacional";
      let tipoServicioCopia = this.tipoServicio == 1 ? "Mensajeria" : "Paqueteria";
      let numPaquetes = this.multiEnvios.length;
      this.datosQueSeVanACopiar =
        this.destinatarioActual.pais +
        "\n" +
        lejaniaDestinoCopia +
        "\n" +
        tipoServicioCopia +
        "\n" +
        numPaquetes +
        "\n" +
        this.remitenteActual.razonSocial.toUpperCase() +
        "\n" +
        this.retornaTitularORemitente+
        "\n" +
        this.remitenteActual.direccion.toUpperCase() +
        "\n" +
        this.remitenteActual.colonia.toUpperCase() +
        "\n" +
        this.remitenteActual.ciudad.toUpperCase() +
        "\n" +
        this.remitenteActual.cp +
        "\n" +
        this.remitenteActual.telefono +
        "\n" +
        this.destinatarioActual.razonSocial.toUpperCase() +
        "\n" +
        this.destinatarioActual.nombre.toUpperCase() +
        "\n" +
        this.destinatarioActual.direccion.toUpperCase() +
        "\n" +
        this.destinatarioActual.colonia.toUpperCase() +
        "\n" +
        this.destinatarioActual.ciudad.toUpperCase() +
        "\n" +
        this.destinatarioActual.cp +
        "\n" +
        this.destinatarioActual.estado +
        "\n" +
        this.destinatarioActual.telefono +
        "\n" +
        this.destinatarioActual.email +
        "\n" +
        this.multiEnvios[0].largo +
        "\n" +
        this.multiEnvios[0].ancho +
        "\n" +
        this.multiEnvios[0].alto +
        "\n" +
        (this.tipoServicio == 2 ? this.multiEnvios[0].pesokg : this.pesoMensajeria) +
        "\n" +
        this.ultimaRef +
        "\n" +
        this.remitenteActual.estado +
        "\n" +
        this.numeroDeCuentaQueSeEstaUsando;
      this.datosQueSeVanACopiar = await this.quitarAcentos(this.datosQueSeVanACopiar);
      this.copiarPaso2();
    },
    copiarPaso2: _.debounce(async function(index) {
      let testingCodeToCopy = document.querySelector("#textAreaDeDatosACopiar");
      testingCodeToCopy.setAttribute("type", "text"); // 不是 hidden 才能複製
      testingCodeToCopy.select();
      var successful = document.execCommand("copy");
    }, 100),
    cortadorDeGuias: _.debounce(async function(index) {
      if (this.guiaRastreo.length == 34) {
        this.guiaRastreo = this.guiaRastreo.substring(
          this.guiaRastreo.length - 12,
          this.guiaRastreo.length
        );
      } else if (this.guiaRastreo.length == 16) {
        this.guiaRastreo = this.guiaRastreo.substring(0, this.guiaRastreo.length - 4);
      }
    }, 200),
    cambiaDeGuiaAInsertar: _.debounce(async function(index) {
      if (this.multiEnvios[index].guia.length >= 12) {
        if (this.multiEnvios[index].guia.length == 34) {
          this.multiEnvios[index].guia = this.multiEnvios[index].guia.substring(
            this.multiEnvios[index].guia.length - 12,
            this.multiEnvios[index].guia.length
          );
        } else if (this.multiEnvios[index].guia.length == 16) {
          this.multiEnvios[index].guia = this.multiEnvios[index].guia.substring(
            0,
            this.multiEnvios[index].guia.length - 4
          );
        }
        this.tabularGuiasEntreEllas(index, "abajo");
      }
    }, 200),
    enfocamesta: _.debounce(async function() {
      this.$refs["guiaNumber0"][0].focus();
    }, 1),
    async cancelarLimpiarEnvio(act = 1) {
      if (act == 1) {
        this.snackBarEnviocancelado = true;
      }

      // this.$refs["botonCompletarALV"].click();
      this.$emit("emitir-cancelar-y-limpiar-remdest");
      this.$emit("limpiar-fracciones-arancelarias-envio");

      this.infoEnvio.Paquetes.InfoPaquetes = [
        {
          pesokg: 0,
          pesovol: 0,
          alto: 0,
          ancho: 0,
          largo: 0,
          guia: ""
        }
      ];
      if (this.infoEnvio.Paquetes.InfoMensajeria) {
        delete this.infoEnvio.Paquetes.InfoMensajeria;
        // this.infoEnvio.Paquetes.InfoMensajeria = [
        //   {
        //     pesokg: 0,
        //     guia: ""
        //   }
        // ];
      }
      this.infoEnvio.Pagos.Abonos[0].cantidad = 0;
      this.guiaRastreo = "";
      this.montoZonaExtendida = 0;
      this.montoEntregaSabado = 0;
      this.montoReempaque = 0;
      this.montoRecoleccion = 0;
      this.montoEmpaque = 0;
      this.infoParaTicket = { InfoPagos: { Total: 0 } };
      this.valorContenido = 0;
      this.seguro = 0;
      //hacemos falso los servicios adicionales
      this.flat19 = false;
      this.flat5 = false;
      this.recoleccionSA = false;
      this.entregaSabado = false;
      this.seguroSA = false;
      this.zonaExtendedidaSA = false;
      this.empaqueSA = false;
      this.reempaqueSA = false;
      this.descripcionMensajeria = "";
      this.pesoMensajeria = 0.5;
      this.pagoCompleto = false;
      this.switchRecoleccion = false;
      this.costoEnvio = 0;
      this.lejaniaDestino == "2";
      this.tipoInternacional = "1";
      this.tipoNacional = "1";
      this.tipoServicio = "2";
      this.descripcion = "";
      this.tipoRecoleccion = "2";
      this.numeroDeEnvios = 1;
      this.multiEnvios = [
        {
          pesokg: 0,
          pesovol: 0,
          largo: 0,
          ancho: 0,
          alto: 0,
          fa: [],
          guia: ""
        }
      ];
      this.actualizaPrecioEnvio();
    },

    async actualizaCuentaUtilizada() {
      let indexCuenta = 0;
      for (let i = 0; i < this.cuentasList.length; i++) {
        if (this.cuentasList[i].ID == this.infoEnvio.Cuenta) {
          indexCuenta = i;
        }
      }
      await this.asignaNumeroDeCuentaAUsar(this.cuentasList[indexCuenta].CUENTA);
    },
    tabularGuiasEntreEllas(index, direccion) {
      try {
        if (direccion == "abajo") {
          this.$refs[`guiaNumber${index + 1}`][0].focus();
        } else if (direccion == "arriba") {
          this.$refs[`guiaNumber${index - 1}`][0].focus();
        }
      } catch (error) {}

      // if (this.multiEnvios.length <= index + 1) {
      //   this.$refs[`guiaNumber${index+1}`][0].focus();
      // }
    },
    enfoca() {
      this.$refs["alto0"][0].focus();
    },
    tabularGuias(index) {
      // console.log(this.multiEnvios.length,index + 1);
      if (this.multiEnvios.length == index + 1) {
        this.enfocamesta();

        // this.$refs["guiaNumber0"][0].focus();
      }
      // console.log(index);
    },
    async calculaPesoVolFinal(index = 0) {
      this.multiEnvios[index].pesovol =
        (parseFloat(
          this.multiEnvios[index].largo == "" ||
            this.multiEnvios[index].largo == null ||
            !this.is_numeric(this.multiEnvios[index].largo)
            ? 0
            : this.multiEnvios[index].largo
        ) *
          parseFloat(
            this.multiEnvios[index].alto == "" ||
              this.multiEnvios[index].alto == null ||
              !this.is_numeric(this.multiEnvios[0].alto)
              ? 0
              : this.multiEnvios[index].alto
          ) *
          parseFloat(
            this.multiEnvios[index].ancho == "" ||
              this.multiEnvios[index].ancho == null ||
              !this.is_numeric(this.multiEnvios[0].ancho)
              ? 0
              : this.multiEnvios[index].ancho
          )) /
        5000;
      await this.calculaValorEnvioInter();
    },
    is_numeric(value) {
      return !isNaN(parseFloat(value)) && isFinite(value);
    },
    async actualizaPrecioEnvio() {
      this.infoEnvio.Pagos.total =
        parseFloat(
          this.costoEnvio == "" || this.costoEnvio == null || !this.is_numeric(this.costoEnvio)
            ? 0
            : this.costoEnvio
        ) +
        parseFloat(
          this.zonaExtendedidaSA == "" ||
            this.zonaExtendedidaSA == null ||
            !this.is_numeric(this.tarifasServicios[4].precio)
            ? 0
            : this.tarifasServicios[4].precio
        ) +
        parseFloat(
          this.flat19 == "" ||
            this.flat19 == null ||
            !this.is_numeric(this.tarifasServicios[3].precio)
            ? 0
            : this.tarifasServicios[3].precio
        ) +
        parseFloat(
          this.flat5 == "" ||
            this.flat5 == null ||
            !this.is_numeric(this.tarifasServicios[2].precio)
            ? 0
            : this.tarifasServicios[2].precio
        ) +
        parseFloat(
          this.seguro == "" || this.seguro == null || !this.is_numeric(this.seguro)
            ? 0
            : this.seguro
        ) +
        parseFloat(
          this.entregaSabado == "" ||
            this.entregaSabado == null ||
            !this.is_numeric(this.tarifasServicios[6].precio)
            ? 0
            : this.tarifasServicios[6].precio
        ) +
        parseFloat(
          this.reempaqueSA == "" ||
            this.reempaqueSA == null ||
            !this.is_numeric(this.tarifasServicios[1].precio)
            ? 0
            : this.tarifasServicios[1].precio
        ) +
        parseFloat(
          this.recoleccionSA == "" ||
            this.recoleccionSA == null ||
            !this.is_numeric(this.tarifasServicios[5].precio * this.multiEnvios.length)
            ? 0
            : this.tarifasServicios[5].precio * this.multiEnvios.length
        ) +
        parseFloat(
          this.empaqueSA == false ||
            this.empaqueSA == null ||
            !this.is_numeric(this.tarifasServicios[0].precio)
            ? 0
            : this.tarifasServicios[0].precio
        ) +
        parseFloat(
          this.valorSeguroNacional == "" ||
            this.valorSeguroNacional == null ||
            !this.is_numeric(this.valorSeguroNacional)
            ? 0
            : this.valorSeguroNacional
        );
    },
    // TODO abre modal fas
    calculaSeguroNacional() {
      if (this.is_numeric(this.valorContenidoNacional)) {
        if (this.valorContenidoNacional <= 2000) {
          this.valorSeguroNacional = 60;
        } else if (this.valorContenidoNacional > 2000 && this.valorContenidoNacional < 4000) {
          this.valorSeguroNacional = 120;
        } else if (this.valorContenidoNacional >= 4000) {
          this.valorSeguroNacional = 180;
        }

        this.actualizaPrecioEnvio();
      }
    },
    calculaSeguroDeEsteEnvio() {
      if (this.remitenteActual.tarifa_seguro) {
        if (this.remitenteActual.tarifa_seguro.length >= 1) {
          // calculamos el porcentaje del seguro a pagar sumando
          // la tarifa del seguro para ver si aumenta o no el costo
          // if(this.is_numeric(parseFloat(this.valorcontenido))){
          if (this.porcentajeSeguroAplicable != null) {
            const totalSuma =
              parseFloat(this.porcentajeSeguroAplicable) +
              parseFloat(this.remitenteActual.tarifa_seguro);
            this.seguro = parseFloat(Math.ceil(this.valorContenido * (totalSuma / 100)).toFixed(2));
          } else {
            this.seguro = 0;
          }
          this.actualizaPrecioEnvio();
          // }else{
          //   this.seguro = 0;
          // }
        }
      }
    },
    ordenarEnviosPorKilos() {
      this.multiEnvios.sort((a, b) => a.pesokg - b.pesokg);
    },
    async agregarFraccionesEnvioUnico() {
      await this.ordenarEnviosPorKilos();
      console.log(this.multiEnvios);
      this.$emit("abre-modal-fa", this.multiEnvios);
    },
    cambiarNumeroEnvios() {
      if (this.tipoServicio == 1) {
        this.numeroDeEnvios = 1;
      }
      if (this.numeroDeEnvios > this.multiEnvios.length) {
        const diferencia = this.numeroDeEnvios - this.multiEnvios.length;
        for (let i = 0; i < diferencia; i++) {
          this.multiEnvios.push({
            pesokg: 0,
            pesovol: 0,
            largo: 0,
            ancho: 0,
            alto: 0,
            guia: "",
            fa: []
          });
        }
      } else if (this.numeroDeEnvios < this.multiEnvios.length) {
        const diferencia2 = this.multiEnvios.length - this.numeroDeEnvios;
        this.multiEnvios.splice(this.numeroDeEnvios, diferencia2);
      }
    },
    cambiaMenus() {
      if (this.lejaniaDestino == 1) {
        this.tipoRecoleccion = "2";
        this.valorSeguroNacional = 0;
        this.valorContenidoNacional = 0;
      } else {
        this.valorContenido = 0;
        this.seguro = 0;
      }
    },
    async completarEnvio() {
      this.deshabilitarBotonCompletar = true;
      await this.ordenarEnviosPorKilos();
      await this.destroyStoreAbonosEnvios();
      await this.destroyStoreInfoEnvio();

      // console.log(this.remitenteActual.envioOcurre == true ? 1 : 0, "rem");
      // console.log(this.destinatarioActual.envioOcurre == true ? 1 : 0, "dest");
      if (!this.remitenteActual.id) {
        if (this.remitenteActual.envioOcurre) {
          // const respR = await this.insertRemitentes({
          //   Nombre_Completo: this.remitenteActual.nombre,
          //   Razon_Social: this.remitenteActual.razonSocial,
          //   Email: this.remitenteActual.email,
          //   Telefono: this.remitenteActual.telefono,
          //   Descuento: "1",
          //   Sucursal: this.logedInUserInfo.sucursal,
          //   Tarifa_Seguro: "0"
          // });
          // this.infoEnvio.Remitente = respR[1];
        } else {
          // const respR = await this.insertRemitentes({
          //   Nombre_Completo: this.remitenteActual.nombre,
          //   Razon_Social: this.remitenteActual.razonSocial,
          //   Direccion: [
          //     {
          //       estado: this.remitenteActual.estado,
          //       municipio: this.remitenteActual.ciudad,
          //       codigopostal: this.remitenteActual.cp,
          //       colonia: this.remitenteActual.colonia,
          //       direccion: this.remitenteActual.direccion
          //     }
          //   ],
          //   Email: this.remitenteActual.email,
          //   Telefono: this.remitenteActual.telefono,
          //   Descuento: "1",
          //   Sucursal: this.logedInUserInfo.sucursal,
          //   Tarifa_Seguro: "0"
          // });
          // this.infoEnvio.Remitente = respR[1];
        }
      } else {
        this.infoEnvio.Remitente = this.remitenteActual.id;
      }

      if (!this.destinatarioActual.id) {
        if (this.destinatarioActual.envioOcurre) {
          // const respD = await this.insertDestinatarios({
          //   Nombre_Completo: this.destinatarioActual.nombre,
          //   Razon_Social: this.destinatarioActual.razonSocial,
          //   Email: this.destinatarioActual.email,
          //   Telefono: this.destinatarioActual.telefono,
          //   Sucursal: this.logedInUserInfo.sucursal
          // });
          // this.infoEnvio.Destinatario = respD[1];
        } else {
          // const respD = await this.insertDestinatarios({
          //   Nombre_Completo: this.destinatarioActual.nombre,
          //   Razon_Social: this.destinatarioActual.razonSocial,
          //   Direccion: [
          //     {
          //       pais: this.destinatarioActual.pais,
          //       estado: this.destinatarioActual.estado,
          //       municipio: this.destinatarioActual.ciudad,
          //       codigopostal: this.destinatarioActual.cp,
          //       colonia: this.destinatarioActual.colonia,
          //       direccion: this.destinatarioActual.direccion
          //     }
          //   ],
          //   Email: this.destinatarioActual.email,
          //   Telefono: this.destinatarioActual.telefono,
          //   Sucursal: this.logedInUserInfo.sucursal
          // });
          // this.infoEnvio.Destinatario = respD[1];
        }
      } else {
        this.infoEnvio.Destinatario = this.destinatarioActual.id;
      }
      //TODO se puede hacer mas eficiente si se revisan las direcciones en front antes de llamar métodos
      if (this.destinatarioActual.envioOcurre == false && this.destinatarioActual.id) {
        this.insertDireccionDest({
          IdDestinatario: this.destinatarioActual.id,
          Direccion: [
            {
              pais: this.destinatarioActual.pais,
              estado: this.destinatarioActual.estado,
              colonia: this.destinatarioActual.colonia,
              direccion: this.destinatarioActual.direccion,
              municipio: this.destinatarioActual.ciudad,
              codigopostal: this.destinatarioActual.cp
            }
          ],
          OcurreOficina: this.destinatarioActual.envioOcurre == true ? 1 : 0
        });
      }
      if (this.remitenteActual.envioOcurre == false && this.remitenteActual.id) {
        this.insertDireccionRem({
          IdRemitente: this.remitenteActual.id,
          Direccion: [
            {
              pais: this.remitenteActual.pais,
              estado: this.remitenteActual.estado,
              colonia: this.remitenteActual.colonia,
              direccion: this.remitenteActual.direccion,
              municipio: this.remitenteActual.ciudad,
              codigopostal: this.remitenteActual.cp
            }
          ],
          OcurreOficina: this.remitenteActual.envioOcurre == true ? 1 : 0
        });
      }
      // return;
      //asigna id de sucursal para ver que sucursal hizo el envio
      this.infoEnvio.Sucursal = this.logedInUserInfo.sucursal;
      //borramos infomensajeria si existe
      if (
        this.lejaniaDestino == 2 &&
        this.tipoServicio == 2 &&
        this.infoEnvio.Paquetes.InfoMensajeria
      ) {
        delete this.infoEnvio.Paquetes.InfoMensajeria;
      }
      // és un multienvio
      if (this.multiEnvios.length >= 1 && this.tipoServicio == 2) {
        // es mensajeria asi que solo se ocuparan pesos en kilogramos y guias
        if (this.tipoServicio == 1) {
          this.infoEnvio.Paquetes.InfoMensajeria = [];
          for (var i = 0; i < this.multiEnvios.length; i++) {
            // eliminamos los atributos que no necesitamos
            delete this.multiEnvios[i].pesovol;
            delete this.multiEnvios[i].alto;
            delete this.multiEnvios[i].ancho;
            delete this.multiEnvios[i].fa;
            delete this.multiEnvios[i].largo;
            // agregamos la propiedad de multienvios al arreglo de mensajeria
            this.infoEnvio.Paquetes.InfoMensajeria.push(this.multiEnvios[i]);
          }
          // el else es para un multienvio de paqueteria, nacional
        } else if (this.tipoServicio == 2 && this.lejaniaDestino == 2) {
          console.log(this.infoEnvio, "info envio");

          for (var i = 0; i < this.multiEnvios.length; i++) {
            // eliminamos los atributos que no necesitamos
            delete this.multiEnvios[i].fa;
          }
          this.infoEnvio.Paquetes.InfoPaquetes = this.multiEnvios;
          //asignamos propiedad de multienvios
          this.infoParaTicket.InfoPaqueteriaN = this.multiEnvios;
        }
        // multienvio internacional de paquetes
        //TODO multienvio internacional de paquetes aqui, es lo que hay que corregir
        else if (this.tipoServicio == 2 && this.lejaniaDestino == 1) {
          this.infoEnvio.Paquetes.InfoPaquetes = this.multiEnvios;
          this.infoEnvio.Paquetes.Descripcion = this.descripcionInter;
          this.infoParaTicket.DescripcionEnvioInter = this.descripcionInter;
          this.infoParaTicket.InfoPaqueteriaN = this.multiEnvios;
        }
      } else {
        //   // este else es para cuando no es multienvio y es de mensajeria
        //   // metemos directamente la informacion tomando de las variables la info
        if (this.tipoServicio == 1) {
          this.infoEnvio.Paquetes.InfoMensajeria = [];
          this.infoEnvio.Paquetes.InfoMensajeria.push({
            pesokg: this.pesoMensajeria,
            guia: this.guiaRastreo
          });
          //informacion de envio sencillo que aparecerá en el ticket
          this.infoParaTicket.InfoMensajeria = {
            pesokg: this.pesoMensajeria,
            guiaRastreo: this.guiaRastreo
          };
        }
      }
      //     // envio sencillo nacional de paqueteria
      //   } else if (this.tipoServicio == 2 && this.lejaniaDestino == 2) {
      //     delete this.multiEnvios[0].fa;
      //     //TODO ojo con el destructuring
      //     // asignamos guia de rastreo a la posicion 0 del
      //     // multi envios que es el que asignamos a los paquetes
      //     this.multiEnvios[0].guia = this.guiaRastreo;
      //     this.multiEnvios[0].pesokg = this.infoEnvio.Paquetes.InfoPaquetes[0].pesokg;
      //     this.infoEnvio.Paquetes.InfoPaquetes = this.multiEnvios;
      //     this.infoParaTicket.InfoPaqueteriaN = this.multiEnvios;
      //     // envio sencillo internacional de paqueteria
      //   } else if (this.tipoServicio == 2 && this.lejaniaDestino == 1) {
      //     this.infoEnvio.Paquetes.InfoPaquetes = this.multiEnvios;
      //   }
      //   // v-model="multiEnvios[index].largo"
      // }
      if (this.lejaniaDestino == 1 && this.tipoInternacional == 1) {
        this.infoParaTicket.tipoEnvio = "internacional Priority";
        // internacional urgente
        this.infoEnvio.Detalle_Envio = 1;
      } else if (this.lejaniaDestino == 1 && this.tipoInternacional == 2) {
        this.infoParaTicket.tipoEnvio = "internacional economy";
        // internacional economico
        this.infoEnvio.Detalle_Envio = 2;
      } else if (this.lejaniaDestino == 2 && this.tipoNacional == 1) {
        this.infoParaTicket.tipoEnvio = "nacional día siguiente";
        // nacional dia siguiente
        this.infoEnvio.Detalle_Envio = 3;
      } else if (this.lejaniaDestino == 2 && this.tipoNacional == 2) {
        this.infoParaTicket.tipoEnvio = "nacional terrestre";
        // nacional terrestre
        this.infoEnvio.Detalle_Envio = 4;
      } else if (this.lejaniaDestino == 3) {
        // regional
        this.infoParaTicket.tipoEnvio = "regional";
        this.infoEnvio.Detalle_Envio = 5;
      }

      //TODO borrar subtotal, solo aplica para paqueteria internacional
      // debe haber fracciones arancelarias insertadas previamente
      if (this.lejaniaDestino == 1 && this.tipoServicio == 2) {
        for (var i = 0; i < this.infoEnvio.Paquetes.InfoPaquetes.length; i++) {
          if (this.infoEnvio.Paquetes.InfoPaquetes[i].fa) {
            for (var j = 0; j < this.infoEnvio.Paquetes.InfoPaquetes[i].fa.length; j++) {
              delete this.infoEnvio.Paquetes.InfoPaquetes[i].fa[j].subtotal;
            }
          }
        }
      }
      let fechaActual = moment().format("L");
      // console.log(fechaActual);
      // var f = new Date();
      // var fechxa = f.getDate() + "/" + (f.getMonth() + 1) + "/" + f.getFullYear();
      if (this.pagoCompleto) {
        this.infoEnvio.Pagos.Abonos[0] = {
          fecha: fechaActual,
          cantidad: this.infoEnvio.Pagos.total,
          tipo_pago: this.metodoPago
        };
        this.infoParaTicket.InfoPagos = {
          fecha: fechaActual,
          cantidad: this.infoEnvio.Pagos.total,
          tipo_pago: this.metodoPago
        };
      } else {
        // CARGAR ABONO this.infoEnvio.Pagos.Abonos.push({ fecha: fechxa, cantidad: this.infoEnvio.Pagos.total });
        this.infoEnvio.Pagos.Abonos[0] = {
          fecha: fechaActual,
          cantidad: this.infoEnvio.Pagos.Abonos[0].cantidad,
          tipo_pago: this.metodoPago
        };
        this.infoParaTicket.InfoPagos = {
          fecha: fechaActual,
          cantidad: this.infoEnvio.Pagos.Abonos[0].cantidad,
          tipo_pago: this.metodoPago
        };
      }

      if (this.tipoServicio == 1) {
        // es mensajeria
        this.infoParaTicket.tipoEnvio = "Mensajeria " + this.infoParaTicket.tipoEnvio;
        this.infoEnvio.Tipo_Servicio = 1;
        delete this.infoEnvio.Paquetes.InfoPaquetes;
        // se asigna a la descripcion de la mensajeria el valor de la opcion del menu seleccionada
        // en caso de que no se haya seleccionado opcion de menu, se toma lo que el
        // usuario haya puesto como texto plano en la descripcion
        if (this.descripcionMensajeria.valor) {
          this.infoEnvio.Paquetes.Descripcion = this.descripcionMensajeria.valor;
          this.infoParaTicket.DescripcionMensajeriaFinal = this.descripcionMensajeria.valor;
        } else {
          this.infoEnvio.Paquetes.Descripcion = this.descripcionMensajeria;
          this.infoParaTicket.DescripcionMensajeriaFinal = this.descripcionMensajeria;
        }
      } else if (this.tipoServicio == 2) {
        // es paqueteria
        this.infoParaTicket.tipoEnvio = "Paqueteria " + this.infoParaTicket.tipoEnvio;
        this.infoEnvio.Tipo_Servicio = 2;
      }

      // asigna descripcion general porque es envio de paqueteria nacional nacional
      if (this.tipoServicio == 2 && this.lejaniaDestino == 2) {
        this.infoEnvio.Paquetes.Descripcion = this.descripcion;
        this.infoParaTicket.DescripcionEnvioNacional = this.descripcion;
      }
      //asigna total a infoticket
      this.infoParaTicket.InfoPagos.Total = this.infoEnvio.Pagos.total;

      //asigna id del usuario logueado a informacion de paquete para ver quien autoriza
      this.infoEnvio.Usuario = this.logedInUserInfo.id;
      // asigna datos de remitentes y destinatarios

      //TODO si no existe remitente lo creamos

      // asigna datos de la direccion al destinatario, en la posicion cero,
      // antes de hacer alguna correccion de direccion
      this.infoEnvio.Direccion[0].estado = this.destinatarioActual.estado;
      this.infoEnvio.Direccion[0].direccion = this.destinatarioActual.direccion;
      this.infoEnvio.Direccion[0].municipio = this.destinatarioActual.ciudad;
      this.infoEnvio.Direccion[0].colonia = this.destinatarioActual.colonia;
      this.infoEnvio.Direccion[0].codigopostal = this.destinatarioActual.cp;
      this.infoEnvio.Direccion[0].pais = this.destinatarioActual.pais;
      //asignar direccion de remitente a la bd//
      this.infoEnvio.DireccionRemitente[0].estado = this.remitenteActual.estado;
      this.infoEnvio.DireccionRemitente[0].direccion = this.remitenteActual.direccion;
      this.infoEnvio.DireccionRemitente[0].municipio = this.remitenteActual.ciudad;
      this.infoEnvio.DireccionRemitente[0].colonia = this.remitenteActual.colonia;
      this.infoEnvio.DireccionRemitente[0].codigopostal = this.remitenteActual.cp;

      this.infoEnvio.Titular = this.titularDeEnvioActual;
      this.infoParaTicket.Titular = this.titularDeEnvioActual;
      //
      // await this.chargeinfoEnvio(this.infoEnvio);
      //titular del envio, si es diferente de cadena vacia este se pone en el ticket

      this.infoParaTicket.InfoUsuario = this.logedInUserInfo;
      this.infoParaTicket.InfoRemitente = this.remitenteActual;
      this.infoParaTicket.InfoDestinatario = this.destinatarioActual;

      //agrega servicios adicionales

      if (this.hayServicioAdicional) {
        this.infoEnvio.Servicio_Adicional = new Object();
        this.infoParaTicket.ServiciosAdicionales = new Object();
        if (this.entregaSabado) {
          this.infoEnvio.Servicio_Adicional.entrega_sabado = this.tarifasServicios[6].precio;
        }
        if (this.empaqueSA) {
          this.infoEnvio.Servicio_Adicional.empaque = this.tarifasServicios[0].precio;
        }
        if (this.zonaExtendedidaSA) {
          this.infoEnvio.Servicio_Adicional.zona_expedida = this.tarifasServicios[4].precio;
        }
        if (this.reempaqueSA) {
          this.infoEnvio.Servicio_Adicional.rempaque = this.tarifasServicios[1].precio;
        }
        if (this.recoleccionSA) {
          this.infoEnvio.Servicio_Adicional.recoleccion =
            this.tarifasServicios[5].precio * this.multiEnvios.length;
        }
        if (this.flat19) {
          this.infoEnvio.Servicio_Adicional.servicio_guia = this.tarifasServicios[3].precio;
        }
        if (this.flat5) {
          this.infoEnvio.Servicio_Adicional.servicio_guia = this.tarifasServicios[2].precio;
        }
        if (this.seguroSA) {
          if (this.lejaniaDestino == 1) {
            this.infoEnvio.Servicio_Adicional.seguro = this.seguro;
            //se agrega valor contenido al objeto de envio solo si es mayor a cero
            if (this.valorcontenido == 0) {
              this.infoEnvio.Servicio_Adicional.valorcontenido = this.valorContenido + "";
            } else {
              this.infoEnvio.Servicio_Adicional.valorcontenido = this.valorContenido + "";
            }
          } else {
            this.infoEnvio.Servicio_Adicional.seguro = this.valorSeguroNacional;
            this.infoEnvio.Servicio_Adicional.valorcontenido = this.valorContenidoNacional;
          }
        }
        this.infoParaTicket.ServiciosAdicionales = this.infoEnvio.Servicio_Adicional;
      }

      // asignar datos para mostrar en ticket
      // console.log(this.remitenteActual);

      this.loaderAntesDeEnvios = true;
      await this.chargeinfoEnvio(this.infoParaTicket);
      //console.log(this.infoParaTicket);
      // TODO bloque insertar envio y reiniciar variable envios
      const resEnvio = await this.insertEnvios(this.infoEnvio);
      if (resEnvio[0] == true) {
        this.deshabilitarBotonCompletar = false;
        await this.getUltimaRef();
        this.loaderAntesDeEnvios = false;

        console.warn("envio exitoso");
        this.idEnviadaEnvioEditar = resEnvio[1].envio.ID;

        await this.chargeInfoEnvioGeneradaDespues(resEnvio[1]);
        this.mostrarModalEdicionEnvios = true;
        // await this.convertirVariableTrue();
        // window.print();
        // await this.convertirVariableFalse();
        // window.print();
        //TODO se limpian variables TODO importante

        // if (!this.switchMantenerdatosEnPantalla) {
        //   await this.cancelarLimpiarEnvio(0);
        // }

        //de todos modos aunque quiera conservar los datos de este envio para el siguiente
        //debemos limpiar las fracciones por un error detectado
        this.$emit("limpiar-fracciones-arancelarias-envio");

        // TODO limpiar valor para proximo envio, revisar
      } else {
        if (resEnvio[0] == false) {
          this.deshabilitarBotonCompletar = false;
          if (resEnvio[1] == "errorinsertenvios") {
            this.dialogErrorEnAccion = true;
            this.mensajeErrorModalErrorEnAccion =
              "Problemas con la conexión al servidor, revise su conexión e intente nuevamente.";
          } else {
            this.dialogErrorEnAccion = true;
            let cadena = JSON.stringify(resEnvio[1].validacion).replace(/[,]/g, "\n");
            cadena.replace(/["{}]/g, "");
            this.mensajeErrorModalErrorEnAccion = resEnvio[1].msg + " " + cadena;
            //TODO AQUI MERO ES
          }
          this.loaderAntesDeEnvios = false;
        }
      }
      // TODO regresamos las variables que se usan para otros tipos de envio
    },
    async llamadaMetodoPosteriorAEdicionDeGuias() {
      await this.convertirVariableTrue();
      window.print();
      await this.convertirVariableFalse();
      window.print();
      //TODO se limpian variables TODO importante
      if (!this.switchMantenerdatosEnPantalla) {
        await this.cancelarLimpiarEnvio(0);
      }
    }
  }
};
</script>

<style lang="css">
.mtll {
  margin-bottom: -15px;
}
.mtl2 {
  margin-top: -15px;
}

.v-data-table > .v-data-table__wrapper > table > tbody > tr > td,
.v-data-table > .v-data-table__wrapper > table > tbody > tr > th,
.v-data-table > .v-data-table__wrapper > table > thead > tr > td,
.v-data-table > .v-data-table__wrapper > table > thead > tr > th,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > td,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > th {
  padding: 0 8px;
  transition: height 0.2s cubic-bezier(0.4, 0, 0.6, 1);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.estiloValorTotal {
  font-size: 40px;
  height: 40px;
  background-color: #e1e9f4;
  margin-top: -4px;
  color: green !important;
}
</style>
